import cuid from 'cuid';
import { IDBService } from '../IDBService.js';
export class LocalReplicaStore extends IDBService {
    constructor() {
        super(...arguments);
        this.get = async ({ transaction, } = {}) => {
            if (this.cached) {
                return this.cached;
            }
            const lookup = await this.run('info', (store) => store.get('localReplicaInfo'), { transaction });
            // not cached, not in db, create it
            if (!lookup) {
                // prevent a race condition if get() is called again while we are
                // creating the replica info
                if (!this._creating) {
                    this._creating = (async () => {
                        // create our own replica info now
                        const replicaId = cuid();
                        const replicaInfo = {
                            type: 'localReplicaInfo',
                            id: replicaId,
                            ackedLogicalTime: null,
                            lastSyncedLogicalTime: null,
                        };
                        await this.run('info', (store) => store.put(replicaInfo), {
                            mode: 'readwrite',
                        });
                        this.cached = replicaInfo;
                    })();
                }
                await this._creating;
                return this.get({ transaction });
            }
            this.cached = lookup;
            return lookup;
        };
        this.update = async (data, { transaction } = {}) => {
            const localReplicaInfo = await this.get({ transaction });
            Object.assign(localReplicaInfo, data);
            await this.run('info', (store) => store.put(localReplicaInfo), {
                mode: 'readwrite',
            });
            this.cached = localReplicaInfo;
        };
        this.reset = async () => {
            const localInfo = await this.get();
            localInfo.ackedLogicalTime = null;
            localInfo.lastSyncedLogicalTime = null;
            await this.run('info', (store) => store.put(localInfo), {
                mode: 'readwrite',
            });
        };
    }
}
//# sourceMappingURL=LocalReplicaStore.js.map